import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';
import { roleGuard } from './core/auth/role.guard';
import { Layout } from './core/layout/layout';
import { BACKOFFICE_SECTIONS } from './config/sections.registry';

export const routes: Routes = [
  {
    path: 'forbidden',
    loadComponent: () => import('./features/forbidden/forbidden').then((m) => m.Forbidden)
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['moderator', 'admin'] },
        loadComponent: () => import('./features/home/home').then((m) => m.Home)
      },
      ...BACKOFFICE_SECTIONS.map((section) => ({
        path: section.route,
        canActivate: [roleGuard],
        data: { roles: section.requiredRealmRoles },
        loadChildren: section.loadChildren
      })),
      { path: '**', redirectTo: '' }
    ]
  }
];
